import React from 'react';
import {Link} from 'react-router-dom';
import styled from 'styled-components';

const BigButton = ({path, children}: {path: string; children: React.ReactNode}) => (
  <LinkButton role="button" to={path}>
    {children}
  </LinkButton>
);

export default BigButton;

const LinkButton = styled(Link)`
  display: block;
  width: 60%;
  padding: calc(2 * var(--margin));
  margin: calc(2 * var(--margin));
  text-align: center;
  white-space: pre-line;
  font-weight: 400;
  font-size: 25px;
  text-decoration: none;
  line-height: 35px;
  color: var(--color-yellow);
  background: var(--color-blue);
  border-radius: 5px;
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.5);

  body:not(.philo-screen) &:hover {
    color: var(--color-blue);
    background: white;
  }
`;
